<template>
<div>
    <Header title="商品详情" />
    <van-swipe class="swiper" :autoplay="5000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in dataSources.slide_list" :key="index">
            <a :href="item.link_url">
                <img :src="item">
            </a>
        </van-swipe-item>
    </van-swipe>

    <div class="goods-info-wrap">
        <div class="title-wrap">
            <p class="price">
                <span class="value">{{dataSources.price}}</span>
                <span class="unit">元 + </span>
                <span class="value">{{dataSources.point}}</span>
                <span class="unit">积分</span>
            </p>
            <p class="mun">{{dataSources.sales_count}}人已兑</p>
        </div>
        <div class="subtitle-wrap">
            <p class="title">{{dataSources.name}}</p>
            <div class="btn-item share-btn-item" @click="_onPressToShare">
                <img :src="Images.icon_share_blue" alt="">
            </div>
        </div>
    </div>

    <div class="goods-tips-wrap">
        <van-cell class="tips-btn-item" is-link title="购物须知" value="点击查看购物需知" @click="isShowRemark = true" />
        <van-cell class="tips-btn-item" is-link title="商品规格" value="请选择规格" @click="onPressShowSKuPopup" />
    </div>

    <div class="card">
        <div class="titAle">
            <div></div>
            <p>商品详情</p>
            <div></div>
        </div>
        <div class="detail-wrap pb-5">
            <!-- <img v-for="(item, index) in dataSources.detail_list" :key="index" :src="item" alt="" class="detail-img"> -->
            <div class="detail-text" v-html="dataSources.detail"></div>
        </div>
    </div>
    <div class="footer">
        <div class="menu" @click="_onPressToNavigate('', 'contactUs')">
            <img :src="Images.icon_service" alt="">
            <p>客服</p>
        </div>
        <div class="btnBox flex-1 ml-1">
            <div class="btn btn2 flex-1" @click="onPressShowSKuPopup">立即兑换</div>
        </div>
    </div>
    <van-popup class="popup" v-model="show" position="bottom">
        <div class="popup-window">
            <div class="goods">
                <div class="left">
                    <img :src="dataSources.slide" alt="">
                </div>
                <div class="right">
                    <p>{{dataSources.name}}</p>
                    <p class="price">
                        <span class="value">{{sku_price || dataSources.price}}</span>
                        <span class="unit">元 + </span>
                        <span class="value">{{sku_point || dataSources.point}}</span>
                        <span class="unit">积分</span>
                    </p>
                </div>
            </div>
            <div class="sku">
                <div class="item" v-for="(item, index) in skuSource" :key="index" :item="item">
                    <p>{{item.name}}</p>
                    <div>
                        <div :class="{active: _item.active}" v-for="(_item, _index) in item.list" :key="_index" :item="_item" @click="onPressSku(index , _index)">
                            <p>{{_item.name}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="num">
                <p>选择数量</p>
                <div>
                    <div @click="onPressNum('-')">-</div>
                    <input type="number" v-model="num">
                    <div @click="onPressNum('+')">+</div>
                </div>
            </div>
            <div class="btnBox flex-1">
                <div class="btn btn2 flex-1" @click.stop="onPressBuyNow">立即兑换</div>
            </div>
        </div>
    </van-popup>

    <van-popup v-model="isShowRemark" closeable position="right" :style="{ height: '100%' }">
        <div class="article-wrap" v-html="dataSources.freight_desc"></div>
    </van-popup>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from '@/components/Header';
import {wxSetup, wxShare} from '@/utils/wxShare'
export default {
    components: {
        'Header': Header,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },

    data() {
        return {
            id: this.$route.query.id,
            show: false,
            isShowRemark: false,
            sku_point: 0,
            sku_price: 0,
            dataSources: {},

            skuSource: [],
            num: 1,
        };
    },

    mounted() {
        this.requestData();
        setTimeout(() => {
            this._setupWechatConfig();
        }, 500);
    },
    methods: {

        // 设置分享参数
        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            let _urlTemp = window.location.href;
            if (_urlTemp.indexOf('is_share=1&uid=') > -1) {
                _urlTemp = _urlTemp.split('is_share=1&uid=')[0] + 'is_share=1&uid=' + this.userInfo.id;
            } else {
                _urlTemp = _urlTemp + '&is_share=1&uid=' + this.userInfo.id;
            }

            console.log('this.userInfo, _urlTemp---->', this.userInfo, _urlTemp);

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                let share_params = {
                    ...result.data.share_params,
                    title: this.dataSources.name,
                    desc: this.dataSources.desc,
                    icon: this.dataSources.image,
                    link: _urlTemp,
                }
                wxShare(result.data.share_config, share_params, () => {});
            }
        },
        
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        // 请求数据
        async requestData() {
            let url = this.API.point_shop_goods_detail;
            let params = {
                id: this.id,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data.goods_detail;
                let sku_list = result.data.goods_detail.sku_list;
                for (let i in sku_list) {
                    for (let j in sku_list[i].list) {
                        if (j == 0) {
                            sku_list[i].list[j].active = true
                        } else {
                            sku_list[i].list[j].active = false
                        }
                    }
                }
                this.skuSource = sku_list
                console.log('sku_list---->', sku_list);
                this.requestSku()
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        // 请求分类规格
        async requestSku() {
            let array = [];
            this.skuSource.forEach(element => {
                element.list.forEach(_element => {
                    _element.active && array.push(_element.name)
                })
            })
            let url = this.API.point_shop_sku_detail;
            let params = {
                goods_id: this.id,
                goods_field: array.join('|')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.sku_point = result.data.sku_point
                this.sku_price = result.data.sku_price
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        // 显示商品属性弹窗
        onPressShowSKuPopup() {
            this.show = !this.show;
        },

        // 点击分类
        onPressSku(index, _index) {
            let sku_list = this.skuSource
            for (let i in sku_list) {
                for (let j in sku_list[i].list) {
                    sku_list[i].list[j].active = false
                }
            }
            sku_list[index].list[_index].active = true
            this.$forceUpdate()
            this.skuSource = sku_list

            this.requestSku()
        },

        // 数量的修改
        onPressNum(type) {
            type === '+' ? this.num++ : this.num--
            this.num = this.num < 0 ? 0 : this.num;
        },

        // 直接下单
        onPressBuyNow() {
            
            let token = this.Lockr.get('token')
            console.log('token---->', token);
            if (!token) {
                return this.$emit(this.Constants.SHOWLOGINDIALOG, true);
            }

            if(!this.userInfo.mobile) {
                return this.$emit(this.Constants.SHOWBINDMOBILEPOPUP, true);
            }

            if(this.dataSources.is_limit > 0 && this.num > this.dataSources.limit_num) {
                return this.AlertManager('该商品您最多只能购买一个！');
            }

            let array = [];
            this.skuSource.forEach(element => {
                element.list.forEach(_element => {
                    _element.active && array.push(_element.name)
                })
            })
            let shop_id = this.dataSources.shop_id
            let data = {
                name: this.dataSources.trade_company_name,
                list: [{
                    check: true,
                    company_id: this.dataSources.trade_company_id,
                    company_name: this.dataSources.trade_company_name,
                    create_time: "",
                    goods_id: this.dataSources.id,
                    goods_sku_id: "",
                    id: "",
                    image: this.dataSources.image,
                    name: this.dataSources.name,
                    price: this.dataSources.price,
                    qty: this.num,
                    shop_id: shop_id,
                    sku_field: array.join('|'),
                    sku_field_name: "",
                    sku_point: this.sku_point,
                    sku_price: this.sku_price,
                    trade_company_id: this.dataSources.trade_company_id,
                }]
            }
            // 本地存储下单商品数据
            let goods_str = JSON.stringify([data])
            this.Lockr.set('point_goods_str', goods_str)
            this._onPressToNavigate('', 'pointOrderConfirm', {is_point: 1});
        },
        
        _onPressToShare() {
            this.$emit(this.Constants.SHOWSHAREPOPUP, true);
        }
    },

};
</script>

<style lang="less" scoped>
.body {
    background-color: #fff;
}

.swiper {
    width: 100%;
    height: 322px;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.goods-info-wrap {
    background: #fff;
    padding: 1rem 1.5rem;

    .title-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .price {
            font-size: 13px;
            color: #EB0000;

            .value {
                font-size: 20px;
            }
        }

        .org_price {
            flex: 1;
            margin: 0 10px;
            font-size: 14px;
            color: #999999;
        }

        .mun {
            font-size: 14px;
            color: #333;
        }
    }

    .subtitle-wrap {
        display: flex;

        .title {
            flex: 1;
            color: #333;
            font-size: 14px;
            margin-top: 8px;
            margin-right: 10px;
        }

        img {
            width: 22px;
            height: 22px;
        }
    }
}

.goods-tips-wrap {
    margin-top: 1rem;
    padding: 0 1.5rem;
    background: #fff;

    .tips-btn-item {
        padding: 1rem 0;
        .van-cell__title {
            font-weight: 600;
            font-size: 1.5rem;
        }
    }
}

.card {
    margin-top: 10px;
    padding: 0px 15px 10px;
    background: #fff;

    >div {
        padding-top: 10px;
        display: flex;
        align-items: center;

        >p {
            color: #333;
            font-weight: 600;
            font-size: 1.5rem;
        }

        >span {
            flex: 1;
            text-align: right;
            font-size: 13px;
            color: #7181EB;
        }
    }

    >p {
        padding-top: 10px;
        font-size: 14px;
        color: #333;
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: center;

        div {
            width: 80px;
            height: 1px;
            border-bottom: 1px dashed #999;
        }

        p {
            margin: 0 6px;
            font-size: 15px;
            color: #7181EB;
            font-weight: 400;
        }
    }

    .detail-wrap {
        padding-bottom: 6rem;
        word-break: break-all;
        flex-direction: column;
    }
}

.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0 15px;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .menu {
        display: flex;
        align-items: center;
        display: flex;
        flex-direction: column;

        img {
            width: 24px;
            height: 24px;
            margin-bottom: 1px;
            object-fit: contain;
        }

        p {
            font-size: 12px;
            color: #333;
        }
    }

    .btnBox {
        display: flex;

        .btn {
            width: 110px;
            height: 35px;
            border-radius: 3px;
            line-height: 35px;
            font-size: 15px;
            text-align: center;
        }

        .btn1 {
            border: 1px solid #7181EB;
            color: #7181EB;
        }

        .btn2 {
            margin-left: 10px;
            background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
            color: #fff;
        }
    }
}

.popup {
    background: transparent;
    display: flex;
    max-height: 70%;
    min-height: 60%;

    .popup-window {
        flex: 1;
        margin-top: 20px;
        background: #fff;
        box-sizing: border-box;
        border-radius: 10px 10px 0 0;
        display: flex;
        flex-direction: column;

        .goods {
            margin: 0 15px;
            display: flex;
            align-items: center;

            .left {
                position: relative;
                margin-right: 10px;
                width: 100px;
                height: 80px;

                >img {
                    position: absolute;
                    bottom: 0;
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 0.5rem;
                }
            }

            .right {
                flex: 1;
                height: 80px;
                padding: 10px 0;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                p {
                    font-size: 13px;
                    color: #333;
                }

                span {
                    font-size: 18px;
                    color: #D81E06;
                }
            }
        }

        .sku {
            flex: 1;
            margin-top: 20px;
            overflow: scroll;

            .item {

                p {
                    margin: 0 15px;
                    font-size: 14px;
                    color: #333;
                }

                >div {
                    margin-left: 15px;
                    display: flex;
                    flex-wrap: wrap;

                    >div {
                        height: 30px;
                        margin: 10px 15px 0 0;
                        border-radius: 15px;
                        padding: 0 10px;
                        background: #f1f1f1;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        p {
                            font-size: 14px;
                            color: #333;
                        }
                    }

                    .active {
                        background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);

                        p {
                            color: #fff;
                        }
                    }
                }
            }
        }

        .num {
            margin: 20px 15px 0;

            >p {
                font-size: 14px;
                color: #333;
            }

            >div {
                margin-top: 10px;
                display: flex;
                align-items: center;

                >div {
                    width: 22px;
                    height: 22px;
                    border-radius: 2px;
                    background: #f1f1f1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                >input {
                    width: 44px;
                    height: 22px;
                    margin: 0 6px;
                    border-radius: 2px;
                    background: #f1f1f1;
                    text-align: center;
                    line-height: 22px;
                    font-size: 13px;
                    color: #333;
                }
            }
        }

        .btnBox {
            padding: 10px 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .btn {
                flex: 1;
                height: 36px;
                border-radius: 3px;
                line-height: 36px;
                text-align: center;
            }

            .btn1 {
                margin-right: 10px;
                border: 1px solid #7181EB;
                font-size: 15px;
                color: #7181EB;
            }

            .btn2 {
                background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
                color: #fff;
            }
        }
    }

}

.van-popup--right {
    width: 100%;
}

.article-wrap {
    padding: 4rem 1rem 1rem;
}
</style>
